import { css } from '@compiled/react';

export const PipelineFrame = ({ url, isFullScreen }: { url: string; isFullScreen: boolean }) => {
	return (
		<iframe
			// eslint-disable-next-line @dev-agents/rules/i18n/text-wrapped-in-format-message
			title="Flow"
			allow="clipboard-read; clipboard-write"
			src={url}
			width="100%"
			height="100%"
			css={[iframeStyles, !isFullScreen && iframeLoadingStyles]}
		/>
	);
};

const iframeStyles = css({
	border: 'none',
});

const iframeLoadingStyles = css({
	position: 'absolute',
	width: 1920,
	height: 1080,
	zoom: 0.01,
	visibility: 'hidden',
	pointerEvents: 'none',
});
